import React from 'react'
import { Badge, Box, Grid, Typography } from '@mui/material'

const RATIO = 6

const RPQSBreadCrumb = ({}) => {
    const steps = [
        { label: 'En attente de saisie 15/03/2026', badge: 3, color: '#92d050' },
        { label: 'En cours de saisie', badge: 2, color: '#dce6f2' },
        { label: 'En attente de vérification', badge: 1, color: '#dce6f2' },
        { label: 'En cours de vérification', color: '#d9d9d9' },
        { label: 'Vérifié', color: '#d9d9d9' },
        { label: 'Publié', color: '#d9d9d9' },
    ]

    const getClipPath = (index) => (
        index === 0
            ? `polygon(0 0, ${100 - RATIO}% 0, 100% 50%, ${100 - RATIO}% 100%, 0% 100%)`
            : `polygon(0 0, ${100 - RATIO}% 0, 100% 50%, ${100 - RATIO}% 100%, 0 100%, ${RATIO}% 50%)`
    )

    return (
        <Grid container alignItems='center'>
            {steps.map((step, index) => (
                <Grid
                    key={index}
                    size={2}
                    textAlign='center'
                    onClick={step.onClick}
                    sx={{
                        cursor: step.onClick ? 'pointer' : 'default',
                    }}
                >
                    <Box
                        sx={{
                            position: 'relative',
                            height: '100%',
                            minHeight: 40,
                        }}
                    >
                        <Box
                            sx={{
                                position: 'absolute',
                                inset: 0,
                                bgcolor: '#000',
                                clipPath: getClipPath(index),
                            }}
                        />
                        <Box
                            sx={{
                                position: 'absolute',
                                inset: '1px 1px 1px 2px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: '0.5rem',
                                bgcolor: step.color,
                                color: '#000',
                                clipPath: getClipPath(index),
                            }}
                        >
                            <Typography
                                variant='body2'
                                fontWeight='bold'
                            >
                                {step.label}
                            </Typography>
                        </Box>
                        {step.badge && (
                            <Badge
                                badgeContent={step.badge}
                                color='primary'
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 20,
                                    '& .MuiBadge-badge': {
                                        height: 30,
                                        width: 30,
                                        borderRadius: '50%',
                                        border: '2px solid black',
                                        fontSize: '1rem',
                                    },
                                }}
                            />
                        )}
                    </Box>
                </Grid>
            ))}
        </Grid>
    )
}

RPQSBreadCrumb.propTypes = {}

export default RPQSBreadCrumb
